import {
  Directive,
  ElementRef,
  OnDestroy,
  OnInit,
} from '@angular/core';

@Directive({
  selector: '[uiAppendToBody]',
  standalone: true,
})
export class UiAppendToBodyDirective implements OnInit, OnDestroy {
  private originalParent: HTMLElement | null = null;

  constructor(private readonly elementRef: ElementRef<HTMLElement>) {}

  public ngOnInit(): void {
    const element = this.elementRef.nativeElement;

    this.originalParent = element.parentElement;

    if (typeof document !== 'undefined' && document.body) {
      document.body.appendChild(element);
    }
  }

  public ngOnDestroy(): void {
    const element = this.elementRef.nativeElement;

    if (element.parentElement) {
      element.parentElement.removeChild(element);
    }
  }
}

